import React from "react";

export const RegisterFormContext = React.createContext({
    meetingId : -1
});
